import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CollapseIcon } from '@ow/icons'
import clsx from 'clsx'
// import { some } from 'lodash-es'
import { StyledMenuVertical, StyledMenuTitle } from './styled/menu-vertical'
import MenuContent from './components/MenuContent'
import RenderIf from '../../render-if'
import { isCurrentUrlChildren } from '../utils'

const MenuVertical = (props) => {
  const {
    style,
    backgroundColor,
    className,
    width,
    textColor,
    menuData,
    collapse,
    hoverFontColor,
    onMenuSelect,
    children,
    secondNav,
    renderNavLevel,
    bottomComponent,
  } = props

  const [_collapse, setCollapse] = useState(collapse)
  const [secondNavData, setSecondNavData] = useState({})

  const collapsedWidth = '73px'

  useEffect(() => {
    console.log('menudata', menuData)
    for (let i = 0; i < menuData.length; i++) {
      const navs = menuData[i]
      if (isCurrentUrlChildren({ navChild: navs })) {
        setSecondNavData(navs || {})
        break
      } else setSecondNavData({})
    }
  }, [menuData])

  const handleCollapse = () => {
    setCollapse(!_collapse)
  }
  const onMenuClick = (e) => {
    setSecondNavData(e || {})
    onMenuSelect(e)
  }

  const renderSecondNav = () => {
    return typeof secondNav === 'function'
      ? secondNav(secondNavData)
      : secondNav
  }

  // const clacWidth = `calc(100% - ${_collapse ? collapsedWidth : width})`

  return (
    // <div className={secondNav || children ? 'flex h-full' : ''}>
    <div
      className={children ? 'h-full flex overflow-hidden' : 'h-full'}
      data-spec="ow-v-menu"
    >
      <StyledMenuVertical
        style={style}
        backgroundColor={backgroundColor}
        className={clsx([
          className,
          // 'bg-dark-900',
          'text-secondary-50',
          'h-full',
        ])}
        width={width}
        collapse={_collapse}
        collapsedWidth={collapsedWidth}
      >
        {/* 头部 */}
        <StyledMenuTitle backgroundColor={backgroundColor}>
          <div
            style={{ color: '#fff', cursor: 'pointer', marginRight: '18px' }}
            onClick={handleCollapse}
          >
            <CollapseIcon width={20} height={20} fill="#9faec2" />
          </div>
        </StyledMenuTitle>

        {/* 内容部分 */}
        <MenuContent
          textColor={textColor}
          backgroundColor={backgroundColor}
          menuData={menuData}
          collapse={_collapse}
          hoverFontColor={hoverFontColor}
          onMenuClick={onMenuClick}
          renderNavLevel={renderNavLevel}
          bottomComponent={bottomComponent}
        />
      </StyledMenuVertical>

      <RenderIf
        isTrue={
          secondNav &&
          children &&
          secondNavData.children &&
          secondNavData.children.length &&
          secondNavData.showChildren
        }
      >
        <div className="flex-1 flex flex-col overflow-hidden">
          {renderSecondNav()}
          <div className="flex-1 overflow-hidden flex">{children}</div>
        </div>
      </RenderIf>
      <RenderIf
        isTrue={
          children && (!secondNavData.children || !secondNavData.showChildren)
        }
      >
        {children}
      </RenderIf>
    </div>
  )
}

// 默认参数
MenuVertical.defaultProps = {
  style: undefined,
  backgroundColor: undefined,
  className: undefined,
  width: '240px',
  textColor: undefined,
  // menuData: [],
  collapse: false,
  hoverFontColor: undefined,
  onMenuSelect: undefined,
  secondNav: undefined,
  children: undefined,
  renderNavLevel: 2,
  bottomComponent: undefined,
}
// 参数类型
MenuVertical.propTypes = {
  style: PropTypes.shape({}),
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  textColor: PropTypes.string,
  // menuData: PropTypes.arrayOf(PropTypes.object),
  collapse: PropTypes.bool,
  hoverFontColor: PropTypes.string,
  onMenuSelect: PropTypes.func,
  secondNav: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  children: PropTypes.node,
  renderNavLevel: PropTypes.oneOf([1, 2]),
  bottomComponent: PropTypes.node,
}

export default MenuVertical
